module.exports = __webpack_public_path__ + "static/bsas004-a670a4056cc93924cd0115be9627efdf.jpg";